<div class="val-facture-vente-fiche-contenu-body">

	@if (!donnees) {
	<div class="val-flex-conteneur val-flex-colonne">
		<val-fonte-icone iconeCss="far fa-frown"></val-fonte-icone>
		<val-simple-libelle [libelle]="'vente.fiche-contenu.introuvable' | transloco"></val-simple-libelle>
	</div>
	}
	@else
	{
	<val-barre-onglets #barreOnglets
					   [onglets]="onglets"
					   (ongletSelectionneChange)="OngletSelectionneChange($event)"
					   (rafraichissementOngletDemande)="RafraichissementOngletDemande($event)">
	</val-barre-onglets>

	@if (barreOnglets.GetIdentifiantOngletSelectionne() === 'details')
	{
	<val-simple-panel>
		<div class="val-flex-conteneur">
			<div class="val-facture-vente-fiche-synthese-entete-conteneur val-flex-conteneur val-flex-colonne val-flex-2">
				<div class="val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-calendar-week"></val-fonte-icone>
					<val-simple-libelle class="val-facture-vente-fiche-synthese-entete-libelle"
										[libelle]="'vente.fiche-contenu.date-facture' | transloco"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-synthese-entete-libelle-contenu"
										[libelle]="donnees.dateFacture | translocoDate"></val-simple-libelle>
				</div>
				<div class="val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-code-branch"></val-fonte-icone>
					<val-simple-libelle class="val-facture-vente-fiche-synthese-entete-libelle"
										[libelle]="'vente.fiche-contenu.processus-metier' | transloco"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-synthese-entete-libelle-contenu"
										[libelle]="donnees.processusMetier"></val-simple-libelle>
				</div>
				<div class="val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-building"></val-fonte-icone>
					<val-simple-libelle class="val-facture-vente-fiche-synthese-entete-libelle"
										[libelle]="'vente.fiche-contenu.client' | transloco"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-synthese-entete-libelle-contenu"
										[libelle]="donnees.tiersFacture"></val-simple-libelle>
				</div>
			</div>

			<div class="val-facture-vente-fiche-synthese-statut-conteneur val-flex-conteneur val-flex-colonne val-flex-1">
				<val-simple-libelle [libelle]="'vente.fiche-contenu.statut-actuel' | transloco"></val-simple-libelle>
				<div class="val-flex-conteneur">
					<div class="val-facture-vente-fiche-synthese-badge-statut val-flex-conteneur"
						 [style.background-color]="donnees.codeCouleurStatutActuel">
						<val-fonte-icone iconeCss="fas fa-circle"></val-fonte-icone>
						<val-simple-libelle class="val-facture-vente-fiche-synthese-statut-libelle"
											[libelle]="donnees.statutActuel"></val-simple-libelle>
					</div>
				</div>
				<val-simple-libelle
					[libelle]="'vente.fiche-contenu.recu-le' | transloco: { date: (donnees.dateStatutActuel | translocoDate), heure: (donnees.dateStatutActuel | translocoDate: { timeStyle: 'short' }) }"></val-simple-libelle>
			</div>

			<div class="val-facture-vente-fiche-synthese-montant-conteneur val-flex-conteneur val-flex-colonne val-flex-1">
				<div class="val-facture-vente-fiche-synthese-montant-zone-conteneur val-flex-conteneur val-flex-colonne">
					<val-simple-libelle [libelle]="'vente.fiche-contenu.montant-encaisse-declare' | transloco"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-synthese-montant-zone-valeur"
										[libelle]="donnees.montantEncaisseDeclare | translocoCurrency"></val-simple-libelle>
				</div>
				@if (donnees.dateEcheance) {
				<div class="val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-calendar-week"></val-fonte-icone>
					<val-simple-libelle [libelle]="'vente.fiche-contenu.echeance' | transloco: { date: (donnees.dateEcheance | translocoDate) }"></val-simple-libelle>
				</div>
				}
			</div>
		</div>
	</val-simple-panel>


	<div class="val-facture-vente-fiche-row val-flex-conteneur">
		<val-simple-panel class="val-flex-1">
			<div class="val-facture-vente-fiche-informations-conteneur">
				<div class="val-facture-vente-fiche-informations-title val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-file-invoice"></val-fonte-icone>
					<val-simple-libelle [libelle]="'vente.fiche-contenu.informations-generales' | transloco"></val-simple-libelle>
				</div>
				<div class="val-facture-vente-fiche-informations-row val-flex-conteneur val-flex-colonne">
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.reference' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.reference"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.date' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.dateFacture | translocoDate"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.processus' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.processusMetier"></val-simple-libelle>
					</div>
				</div>

				<div class="val-facture-vente-fiche-informations-separateur"></div>

				<div class="val-facture-vente-fiche-informations-title val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-building"></val-fonte-icone>
					<val-simple-libelle [libelle]="'vente.fiche-contenu.tiers-facture' | transloco"></val-simple-libelle>
				</div>
				<div class="val-facture-vente-fiche-informations-row val-flex-conteneur val-flex-colonne">
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.raison-sociale' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.tiersFacture"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.interlocuteur' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.interlocuteurTiersFacture"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.email' | transloco"></val-simple-libelle>
						<a [hidden]="!donnees.emailInterlocuteurTiersFacture"
						   [href]="'mailto:' + donnees.emailInterlocuteurTiersFacture"
						   class="val-facture-vente-fiche-informations-contenu val-flex-conteneur val-align-items-center">
							<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
												[libelle]="donnees.emailInterlocuteurTiersFacture"></val-simple-libelle>
							<val-fonte-icone iconeCss="far fa-envelope"></val-fonte-icone>
						</a>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.identifiant-adressage' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.identifiantAdressageTiersFacture"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.identifiant-complementaire' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.identifiantComplementaireTiersFacture"></val-simple-libelle>
					</div>
				</div>
			</div>
		</val-simple-panel>

		@if (donnees.acheteurReference || donnees.projetReference || donnees.contratReference || donnees.acheteurBonCommandeReference || donnees.appelOffreReference) {
		<val-simple-panel class="val-flex-1">
			<div class="val-facture-vente-fiche-informations-conteneur">
				<div class="val-facture-vente-fiche-informations-title val-flex-conteneur">
					<val-fonte-icone iconeCss="fas fa-tags"></val-fonte-icone>
					<val-simple-libelle [libelle]="'vente.fiche-contenu.references-externes' | transloco"></val-simple-libelle>
				</div>
				<div class="val-facture-vente-fiche-informations-row val-flex-conteneur val-flex-colonne">
					@if (donnees.acheteurReference) {
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.reference-contact-acheteur' | transloco"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.acheteurReference"></val-simple-libelle>
					</div>
					}

					@if (donnees.projetReference) {
					<div class="val-facture-vente-fiche-informations-separateur"></div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.reference-projet' | transloco"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.projetReference"></val-simple-libelle>
					</div>
					}

					@if (donnees.contratReference) {
					<div class="val-facture-vente-fiche-informations-separateur"></div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.reference-contrat' | transloco"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.contratReference"></val-simple-libelle>
					</div>
					}

					@if (donnees.acheteurBonCommandeReference) {
					<div class="val-facture-vente-fiche-informations-separateur"></div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.reference-bon-commande-acheteur' | transloco"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.acheteurBonCommandeReference"></val-simple-libelle>
					</div>
					}

					@if (donnees.appelOffreReference) {
					<div class="val-facture-vente-fiche-informations-separateur"></div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu-libelle"
											[libelle]="'vente.fiche-contenu.reference-appel-offres' | transloco"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-informations-contenu"
											[libelle]="donnees.appelOffreReference"></val-simple-libelle>
					</div>
					}
				</div>
			</div>
		</val-simple-panel>
		}

		<val-simple-panel class="val-flex-2">
			<div class="val-facture-vente-fiche-montants-conteneur">
				<div class="val-facture-vente-fiche-montants-title val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-money-bill-alt"></val-fonte-icone>
					<val-simple-libelle [libelle]="'vente.fiche-contenu.montants' | transloco"></val-simple-libelle>
				</div>

				<div class="val-facture-vente-fiche-montants-montant-conteneur val-flex-conteneur">
					<div class="val-facture-vente-fiche-montants-montant-zone montant-ht val-flex-conteneur val-flex-colonne val-flex-1">
						<val-simple-libelle class="val-facture-vente-fiche-montants-montant-zone-valeur"
											[libelle]="donnees.montantHt | translocoCurrency"></val-simple-libelle>
						<val-simple-libelle [libelle]="'vente.fiche-contenu.ht' | transloco"></val-simple-libelle>
					</div>

					<div class="val-facture-vente-fiche-montants-montant-zone montant-tva val-flex-conteneur val-flex-colonne val-flex-1">
						<val-simple-libelle class="val-facture-vente-fiche-montants-montant-zone-valeur"
											[libelle]="donnees.montantTva | translocoCurrency"></val-simple-libelle>
						<val-simple-libelle [libelle]="'vente.fiche-contenu.tva' | transloco"></val-simple-libelle>
					</div>

					<div class="val-facture-vente-fiche-montants-montant-zone montant-ttc val-flex-conteneur val-flex-colonne val-flex-1">
						<val-simple-libelle class="val-facture-vente-fiche-montants-montant-zone-valeur"
											[libelle]="donnees.montantTtc | translocoCurrency"></val-simple-libelle>
						<val-simple-libelle [libelle]="'vente.fiche-contenu.ttc' | transloco"></val-simple-libelle>
					</div>
				</div>

				<div class="val-facture-vente-fiche-montants-separateur"></div>

				<div class="val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-credit-card-blank"></val-fonte-icone>
					<val-simple-libelle class="val-facture-vente-fiche-montants-contenu-libelle"
										[libelle]="'vente.fiche-contenu.acompte' | transloco"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-montants-contenu"
										[libelle]="donnees.montantAcompte | translocoCurrency"></val-simple-libelle>
				</div>

				<div class="val-facture-vente-fiche-montants-separateur"></div>

				<div class="val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-file-invoice-dollar"></val-fonte-icone>
					<val-simple-libelle class="val-facture-vente-fiche-montants-contenu-libelle"
										[libelle]="'vente.fiche-contenu.net-a-payer' | transloco"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-montants-contenu"
										[libelle]="donnees.montantNetAPayer | translocoCurrency"></val-simple-libelle>
				</div>

				<div class="val-facture-vente-fiche-montants-separateur"></div>

				@if (donnees.dateEcheance) {
				<div class="val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-calendar-week"></val-fonte-icone>
					<val-simple-libelle class="val-facture-vente-fiche-montants-contenu-libelle"
										[libelle]="'vente.fiche-contenu.date-echeance' | transloco"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-montants-contenu blue"
										[libelle]="donnees.dateEcheance | translocoDate"></val-simple-libelle>
					<val-simple-libelle class="val-facture-vente-fiche-montants-contenu gray"
										[libelle]="donnees.nombreJoursAvantEcheance !== null ? (donnees.nombreJoursAvantEcheance < 0 ? ('vente.fiche-contenu.echeance-depassee' | transloco: { nb: -donnees.nombreJoursAvantEcheance }) : ('vente.fiche-contenu.echeance-a-venir' | transloco: { nb: donnees.nombreJoursAvantEcheance })) : ''"></val-simple-libelle>
				</div>
				}
			</div>
		</val-simple-panel>
	</div>

	<div class="val-facture-vente-fiche-row val-flex-conteneur">
		<val-simple-panel class="val-flex-1">
			<div class="val-facture-vente-fiche-historique-conteneur">
				<div class="val-facture-vente-fiche-historique-title val-flex-conteneur">
					<val-fonte-icone iconeCss="far fa-history"></val-fonte-icone>
					<val-simple-libelle [libelle]="'vente.fiche-contenu.historique.titre' | transloco"></val-simple-libelle>
				</div>
				<val-grille #grilleHistorique
							[colonnes]="colonnes_historique"
							champSelection="id"
							[donnees]="donnees_historique"
							[simpleSelection]="true"
							[filtrable]="false"
							[menuColonne]="false"
							[colonneSelection]="false"
							[pageable]="true"
							[taillePage]="5"
							(selectionChange)="HistoriqueSelectionChange($event)">
				</val-grille>

				@if (afficherErreursConformite)
				{
				<val-simple-panel class="val-facture-vente-fiche-historique-erreurs-panel" couleurFond="#FCF3F4" couleurBord="#E67161" couleurTitre="#b5141e">
					<div class="val-facture-vente-fiche-historique-erreurs-conteneur">
						<div class="val-facture-vente-fiche-historique-title val-flex-conteneur">
							<val-fonte-icone iconeCss="fas fa-exclamation-triangle" couleurIcone="#b5141e"></val-fonte-icone>
							<val-simple-libelle [libelle]="'vente.fiche-contenu.erreurs-conformite.titre' | transloco"></val-simple-libelle>
						</div>
						<val-simple-libelle class="val-facture-vente-fiche-historique-erreurs-explication"
											[libelle]="'vente.fiche-contenu.erreurs-conformite.explication' | transloco">
						</val-simple-libelle>
						<val-grille [colonnes]="colonnes_erreurs_conformite"
									champSelection="codeRegle"
									[donnees]="donnees_erreurs_conformite"
									[simpleSelection]="true"
									[filtrable]="false"
									[menuColonne]="false"
									[colonneSelection]="false">
						</val-grille>
					</div>
				</val-simple-panel>
				}

				@if (afficherRetourAcheteur && retourAcheteurSelectionne)
				{
				<val-simple-panel class="val-facture-vente-fiche-historique-retour-acheteur-panel" couleurFond="#F9EBE8" couleurBord="#b5141e" couleurTitre="#b5141e">
					<div class="val-facture-vente-fiche-historique-retour-acheteur-conteneur">
						<div class="val-facture-vente-fiche-historique-title val-flex-conteneur">
							<val-fonte-icone iconeCss="fas fa-bell" couleurIcone="#b5141e"></val-fonte-icone>
							<val-simple-libelle [libelle]="'vente.fiche-contenu.retour-acheteur.titre' | transloco"></val-simple-libelle>
						</div>
						<val-simple-libelle class="val-facture-vente-fiche-historique-retour-acheteur-explication"
											[libelle]="'vente.fiche-contenu.retour-acheteur.explication' | transloco">
						</val-simple-libelle>
						<div class="val-facture-vente-fiche-historique-retour-acheteur-row val-flex-conteneur val-flex-colonne">
							<div class="val-flex-conteneur">
								<val-simple-libelle class="val-facture-vente-fiche-historique-retour-acheteur-libelle" [libelle]="'vente.commun.motif' | transloco"></val-simple-libelle>
								<val-simple-libelle [libelle]="retourAcheteurSelectionne.motif"></val-simple-libelle>
							</div>
							<div class="val-flex-conteneur">
								<val-simple-libelle class="val-facture-vente-fiche-historique-retour-acheteur-libelle" [libelle]="'vente.commun.description' | transloco"></val-simple-libelle>
								<val-simple-libelle [libelle]="retourAcheteurSelectionne.motifDescription"></val-simple-libelle>
							</div>
							<div class="val-flex-conteneur">
								<val-simple-libelle class="val-facture-vente-fiche-historique-retour-acheteur-libelle" [libelle]="'vente.fiche-contenu.retour-acheteur.note-complementaire' | transloco"></val-simple-libelle>
								<div class="val-flex-conteneur val-flex-colonne">
									@for (ligne of ParseNote(retourAcheteurSelectionne.note); track ligne) {
									<val-simple-libelle [libelle]="ligne"></val-simple-libelle>
									}
								</div>
							</div>
						</div>
					</div>
				</val-simple-panel>
				}
			</div>
		</val-simple-panel>
	</div>
	}

	@if (barreOnglets.GetIdentifiantOngletSelectionne() === 'encaissements')
	{
	<div class="val-facture-vente-fiche-encaissements-conteneur val-flex-conteneur">
		<val-simple-panel class="val-flex-2">
			<div class="val-facture-vente-fiche-encaissements-grille-conteneur">
				<val-grille #grilleEncaissements
							[colonnes]="colonnes_encaissements"
							champSelection="id"
							[donnees]="donnees_encaissements"
							[simpleSelection]="true"
							[filtrable]="false"
							[menuColonne]="false"
							[colonneSelection]="false"
							[pageable]="true"
							[taillePage]="15"
							(selectionChange)="EncaissementSelectionChange($event)">
				</val-grille>
			</div>
		</val-simple-panel>
		@if (encaissementSelectionneErreur)
		{
		<val-simple-panel class="val-flex-1" couleurFond="#FCF3F4" couleurBord="#E67161" couleurTitre="#b5141e">
			<div class="val-facture-vente-fiche-encaissements-erreur-conteneur">
				<div class="val-facture-vente-fiche-historique-title val-flex-conteneur">
					<val-fonte-icone iconeCss="fas fa-exclamation-triangle" couleurIcone="#b5141e"></val-fonte-icone>
					<val-simple-libelle [libelle]="'vente.fiche-contenu.encaissements.detail-erreur' | transloco"></val-simple-libelle>
				</div>
				<div class="val-facture-vente-fiche-encaissements-erreur-row val-flex-conteneur val-flex-colonne">
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-encaissements-erreur-libelle" [libelle]="'vente.fiche-contenu.encaissements.code-erreur' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-encaissements-erreur-valeur" [libelle]="encaissementSelectionneErreur.transmissionErreurCode ?? ''"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-encaissements-erreur-libelle" [libelle]="'vente.commun.statut' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-encaissements-erreur-valeur" [libelle]="encaissementSelectionneErreur.transmissionErreur ?? ''"></val-simple-libelle>
					</div>
					<div class="val-flex-conteneur">
						<val-simple-libelle class="val-facture-vente-fiche-encaissements-erreur-libelle" [libelle]="'vente.commun.description' | transloco"></val-simple-libelle>
						<val-simple-libelle class="val-facture-vente-fiche-encaissements-erreur-valeur" [libelle]="encaissementSelectionneErreur.transmissionErreurDescription ?? ''"></val-simple-libelle>
					</div>
				</div>
			</div>
		</val-simple-panel>
		}
	</div>
	}

	@if (barreOnglets.GetIdentifiantOngletSelectionne() === 'documents')
	{
	<div class="val-facture-vente-fiche-documents-conteneur val-flex-conteneur">
		<val-simple-panel class="val-flex-1">
			<div class="val-facture-vente-fiche-documents-grille-conteneur">
				<val-grille [colonnes]="colonnes_documents"
							champSelection="id"
							[donnees]="donnees_documents"
							[simpleSelection]="true"
							[menuColonne]="false"
							[colonneSelection]="false"
							(selectionChange)="DocumentSelectionChange($event)"
							(colonneBoutonIconeClick)="DocumentColonneBoutonIconeClick($event)">
				</val-grille>
			</div>
		</val-simple-panel>
		@if (documentSelectionne)
		{
		<val-simple-panel class="val-flex-1">
			<div class="val-facture-vente-fiche-pdf-viewer-conteneur">
				<kendo-pdfviewer [url]="urlDocumentSelectionne"
								 [saveFileName]="nomFichierDocumentSelectionne"
								 [tools]="['search', 'selection', 'zoomInOut', 'spacer', 'pager', 'download', 'print']"
								 [zoom]="1">
				</kendo-pdfviewer>
			</div>
		</val-simple-panel>
		}
	</div>
	}

	}

	<val-attente-operation [visible]="operationEnCours"></val-attente-operation>

	<val-modifier-statut-dialogue #modifierStatutDialogue></val-modifier-statut-dialogue>

</div>
